import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import ChangeUserByVpsUsComponent from "../../../../components/Customer/vps_us/ChangeUserByVpsUsComponent";

const PageChangeUserByVpsUs = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ChangeUserByVpsUsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default PageChangeUserByVpsUs;